import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, NgZone, OnInit, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FileService } from 'app/shared/services/file.service';
import { FileSizePipe } from 'app/shared/pipes/file-size.pipe';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-df-transaction-file-upload',
  templateUrl: './df-transaction-file-upload.component.html',
  styleUrls: ['./df-transaction-file-upload.component.scss']
})
export class DfTransactionFileUploadComponent implements OnInit {

  @ViewChild('fileUpload') private fileUpload: ElementRef;

  @Input() public acceptedFileTypes: Array<String> = [];
  @Input() public acceptedFileExtensions: Array<String> = [];
  @Input() public labelKey: string;
  @Input() public maxFileSize = 5000000;
  @Input() public id: string;
  @Output() public onFileAdded: EventEmitter<File> = new EventEmitter<File>();

  constructor(private cd: ChangeDetectorRef,
              private toastrService: ToastrService,
              private translateService: TranslateService,
              private ngZone: NgZone,
              private fileSizePipe: FileSizePipe,
              private el: ElementRef
  ) {
  }

  ngOnInit(): void {
    this.ngZone.runOutsideAngular(() => {


      this.el.nativeElement.ondragover = () => {
        return false;
      };

      this.el.nativeElement.ondrop = (event) => {
        this.ngZone.run(() => {
          if (event.dataTransfer != null) {
            const files = event.dataTransfer.files;
            if (files.length > 0) {
              this.emitFile(files);
            }
          }
        })
        return false;
      };
    });
  }

  public emitFile(event: any): void {
    const file = event[0] as File;

    if (file.size > this.maxFileSize) {
      this.toastrService.warning(this.translateService.instant(
        'file-upload.error.too-big',
        {maxFileSize: this.fileSizePipe.transform(this.maxFileSize)})
      );
    } else if (this.fileTypeIsForbidden(file)) {
      this.toastrService.warning(
        this.translateService.instant(
          'file-upload.error.type-not-supported',
          {fileType: file.type}
        )
      );
    } else if (this.fileExtensionIsForbidden(file)) {
      this.toastrService.warning(
        this.translateService.instant('file-upload.error.extension-not-supported')
      );
    } else {
      this.onFileAdded.emit(file);
      this.fileUpload.nativeElement.value = '';
    }
  }

  private fileTypeIsForbidden(file: File) {
    return this.acceptedFileTypes.length !== 0
      && this.acceptedFileTypes
        .map(fileType => fileType.toUpperCase())
        .indexOf(file.type.toUpperCase()) === -1
  }

  private fileExtensionIsForbidden(file: File) {
    return this.acceptedFileExtensions.length !== 0
      && this.acceptedFileExtensions
        .map(fileExtension => fileExtension.toUpperCase())
        .indexOf(FileService.extractFileExtension(file.name).toUpperCase()) === -1
  }
}
